module.exports = __webpack_public_path__ + "img/956.1ee5501c.png";